module.exports = __webpack_public_path__ + "static/media/wind-turbines-3.c5aa934d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/wind-turbines-3.jpeg
// module id = 1838
// module chunks = 0